module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fChc4EsA.e83b8f97.woff2";